import { Component, EventEmitter, Input, Output } from '@angular/core';
import { TabelPaging } from '../../interfaces/table';
import { PCTableOutputModel } from '../../models/pc-table-input-model';

@Component({
  selector: 'app-pcpaging',
  templateUrl: './pcpaging.component.html',
  styleUrls: ['./pcpaging.component.css']
})
export class PCPagingComponent {

  @Input() paging?: TabelPaging;
  @Input() isDropDown?: boolean=false;
  @Input() className?: string;
  @Output() parentAction = new EventEmitter<PCTableOutputModel>();

  public loading: boolean = false;
  public pagingSize:number=10;
  
  public changePage(element: number) {
    this.parentAction.next(new PCTableOutputModel('Paging', element));
  }
  
  public changePageSize() {
    this.parentAction.next(new PCTableOutputModel('PageSize', this.pagingSize));
  }
}
